export default __webpack_public_path__ + "static/media/bg-image.b9481c17.svg";